import { Actions } from "../constants/actionTypes";

const initialState = {};

export function sitesReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SET_ALL_SITES:
      return { ...state, allSites: action.data };
    case Actions.SET_SITE_DETAILS:
      return { ...state, sitePath: action.data };
    case Actions.SET_SITES_LB_ARN:
      return {
        ...state,
        siteArns: {
          ...state.siteArns,
          [action.data.siteId]: action.data.lbArn,
        },
      };
    case Actions.SET_SELECTED_SITE_DETAILS:
      return {
        ...state,
        selectedSite: {
          ...action.data,
        },
      };
    case Actions.SET_TOGGLE_STAGING:
      return {
        ...state,
        stagingToggle: {
          ...action.data,
        },
      };
    case Actions.SET_SELECTED_DOMAIN:
      return {
        ...state,
        selectedDomain: {
          ...action.data,
        },
      };
    case Actions.SET_STAGING_DOMAIN_LIST:
      return {
        ...state,
        stagingDomainList: {
          ...action.data,
        },
      };
    case Actions.SET_SITE_OVERVIEW:
      return {
        ...state,
        siteDetails: action.data,
      };
    case Actions.SET_FILE_UPLOAD_DETAILS:
      return { ...state, uploadDetails: action.data };
    // Global upload progress — merged so partial updates (e.g. only `uploaded`)
    // don't wipe the rest. Drives the app-wide floating upload widget so it
    // keeps showing while the user navigates away from the File Explorer.
    case Actions.SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: { ...state.uploadProgress, ...action.data },
      };
    case Actions.RESET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: {
          active: false,
          minimized: false,
          completed: false,
          uploaded: 0,
          total: 0,
          returnPath: "",
        },
      };
    case Actions.SET_SITE_IMAGE:
      return { ...state, siteImage: action.data };
    case Actions.SET_DOMAIN_SSL_STATUS:
      return {
        ...state,
        sslStatus: action.data,
      };
    case Actions.SET_GRAPH_DETAILS:
      return { ...state, graphDetails: action.data };
    case Actions.SET_TOP_SITES:
      return { ...state, topSites: action.data };
    case Actions.SET_SITES_LIST:
      return { ...state, sitesList: action.data };
    case Actions.SET_STAGING_TIMESTAMP:
      return { ...state, credits: action.data };
    case Actions.SET_MIGRATION_PROGRESS:
      return { ...state, migrationProgress: action.data };
    case Actions.SET_PLAN_OVERGAUGE:
      return { ...state, overgauge: action.data };
    case Actions.SET_INSTANCE_PASSWORD:
      return { ...state, instancePassword: action.data };
    case Actions.SET_SITES_RESTORES:
    case Actions.SET_BACKUP_DETAILS:
    case Actions.SET_EBS_BACKUP_DETAILS:
    case Actions.SET_ALERTS_DETAILS:
    case Actions.SET_WAF:
    case Actions.SET_LIST_SFTP_USER:
    case Actions.SET_EBS_SFTP_DETAILS:
    case Actions.SET_SITE_FILES:
    case Actions.SET_FILE_EXPLORER_LOCATION:
    case Actions.SET_S3_SIGNED_URL:
    case Actions.SET_DEDICATED_STORAGE:
    case Actions.SET_DEDICATED_PHP_CREDS:
      return {
        ...state,
        selectedSite: {
          ...state.selectedSite,
          [getKeyFromActionType(action.type)]: action.data,
        },
      };

    default:
      return state;
  }
}

function getKeyFromActionType(actionType) {
  switch (actionType) {
    case Actions.SET_SITES_RESTORES:
      return "restoreDetails";
    case Actions.SET_BACKUP_DETAILS:
      return "backupDetails";
    case Actions.SET_EBS_BACKUP_DETAILS:
      return "ebsBackupDetails";
    case Actions.SET_ALERTS_DETAILS:
      return "alertDetails";
    case Actions.SET_WAF:
      return "wafStatus";
    case Actions.SET_LIST_SFTP_USER:
      return "sftpDetails";
    case Actions.SET_EBS_SFTP_DETAILS:
      return "ebsSftp";
    case Actions.SET_FILE_EXPLORER_LOCATION:
      return "fileExplorerLocation";
    case Actions.SET_SITE_FILES:
      return "files";
    case Actions.SET_S3_SIGNED_URL:
      return "s3SignedUrl";
    case Actions.SET_DEDICATED_STORAGE:
      return "dedicatedStorage";
    case Actions.SET_DEDICATED_PHP_CREDS:
      return "phpCreds";
    default:
      return;
  }
}
